import './bringoz.module';

import './commons';
import './configuration-profiles';
import './contracts'
import './authentication';
import './iam';
import './organizations';
import './sites';
import './skills';
import './persistence-layer';
import './globals';
import './admins';
import './policies';
import './site-preferences';
import './text-templates';
import './notifications';
import './tags';
import './messages';
import './search';
import './sub-tasks';
import './branches';
import './cancellation-reasons';
import './depots';
import './payments';
import './commissions';
import './agreements';
import './terms';
import './attachments';
import './customers';
import './service-points';
import './labels';
import './reports';
import './working-slots';
import './workload';
import './vehicles';
import './wallets';
import './webhooks';
import './addresses';
import './map';
import './itineraries';
import './service-areas';
import './tasks';
import './threePL';
import './user';
import './shippers';
import './account';
import './agents';
import './agent-inventory';
import './deliveries';
import './auctions';
import './batch';
import './billing-accounts';
import './routes';
import './lean-planning';
import './logistics-vehicle'
import './oms';
import './orders';
import './price-plan';
import './planning';
import './survey';
import './devices';
import './document-management';
import './fulfillment';
import './self-pickups';
import './resources';
import './schedule';
import './service-analysis';
import './coordinations';
import './point-of-sale';
import './integrations';
import './expenses';
import './rule-engine';
import './chat';
import './content-templates';
import './dashboards';
import './groups';
import './action-reasons';
import './order-planning-configuration';
import './teams';
import './scheduling-project';
import './recommendation';
import './ai-agents';
import './timekeeping';

import './bringoz.config';
import './config.menu';
import './split-constants.const';

import './gtag.provider';
import './heap.provider';
import './intercom.provider';
import './browser-print.provider';
import './sisence.provider';

import './animate.scss';
import './bringoz.scss';
import './bringoz-variables.scss';
import './courier-marker.scss';
import './print.scss';

